export default {
  form: {
    address: {
      label: 'Adresse',
      placeholder: 'Rue + numéro',
    },
    city: {
      label: 'Ville',
      placeholder: 'Ville',
    },
    state: {
      label: 'État',
      placeholder: 'Sélectionner un état',
    },
    country: {
      label: 'Pays',
      placeholder: 'Sélectionner un pays',
    },
    zip_code: {
      label: 'Code postal',
      placeholder: 'Code postal',
    },
  },
};
